import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootReducer } from '../redux/rootReducer'

const SLIDE_WIDTH = 800
const SLIDE_HEIGHT = 500

const SlidePreview = () => {
  const [scale, setScale] = useState(1)
  const html = useSelector((state: RootReducer) => state.manageSlidesReducer.activeSlide?.html || '')
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (containerRef.current) {
      const width = containerRef.current.getBoundingClientRect().width
      const slideWidth = 800
      const scale = width / slideWidth
      setScale(scale)
    }
  }, [])

  return (
    <div ref={containerRef} className="flex-1">
      <div
        className="relative shadow-xl"
        style={{
          width: `${SLIDE_WIDTH * scale}px`,
          height: `${SLIDE_HEIGHT * scale}px`,
          overflow: 'hidden'
        }}>
        <div
          className="origin-top-left absolute top-0 left-0"
          style={{
            transform: `scale(${scale})`,
            transformOrigin: 'top left'
          }}
          ref={(node) => {
            if (node) {
              if (!node.shadowRoot) {
                const shadowRoot = node.attachShadow({ mode: 'open' })
                shadowRoot.innerHTML = html
              } else {
                node.shadowRoot.innerHTML = html
              }
            }
          }}
        />
      </div>
    </div>
  )
}

export default SlidePreview
